// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__aWXsh","right":"styles_right__3GeQu"};